import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function AuthPromptDialog({ open, onClose, onConfirm, title, body }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ display: "flex", textAlign: "center", margin: "0 auto", alignItems: "center", gap: 1 }}
      >
        <LockOutlinedIcon color="primary" />
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ textAlign: "center" }} color="text.secondary" gutterBottom>
          {body}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexDirection: "column", gap: 1 }}>
        <Button variant="contained" fullWidth onClick={onConfirm}>
          Create account / Sign in
        </Button>
        <Button variant="text" fullWidth onClick={onClose}>
          Maybe later
        </Button>
      </DialogActions>
    </Dialog>
  );
}
